import { ErrorKey } from '../app-active-error/ErrorKey';
import { getSentryExtra } from '../error/getSentryExtra';
import { ExperimentKeys } from '../experiments/ExperimentKeys';
import { ExperimentParameterGroup } from '../experiments/ExperimentParameterGroup';
import { EndpointKey } from '../http/EndpointKey';
import Logger from '../lib/Logger';
import { handleRecaptchaFailed, handleRecaptchaMissingInformation } from '../recaptcha/utils/recaptchaHandlers';
import { getHasRecaptchaFailed, getIsMissingRecaptchaInformation } from '../recaptcha/utils/recaptchaMessageParsing';
import { setError } from '../store/error/action-creators';
import { getIsActiveAndAssignedToVariant } from '../store/experiments/selectors';
import parseErrorData from '../store/signup-data-validation/utils/parseErrorData';
import { Tracker } from '../store/tracking/action-creators';
import { IdentityVerificationMethod } from '../tracking/IdentityVerificationMethod';
const LOG = Logger.getLogger('handleInitiateVerificationResponse');
export const handleInitiateVerificationSuccess = dispatch => {
  dispatch(Tracker.signupInteraction('send-verification-email-success'));
  dispatch(Tracker.verifyIdentityStarted(IdentityVerificationMethod.CodeVerification));
};
export const handleInitiateVerificationError = (error, dispatch, getState) => {
  let errorMessage = 'unknown-message';
  if (error.data) {
    const parsed = parseErrorData(error.data);
    errorMessage = parsed.message;
  }
  LOG.error('/initiateVerification error', {
    extra: getSentryExtra(error)
  });
  const isInACQ173VariantB = getIsActiveAndAssignedToVariant(getState(), ExperimentKeys.ACQ0173, [ExperimentParameterGroup.Variant_B]);
  dispatch(Tracker.signupInteraction('send-verification-email-fail'));
  const isRateLimitedError = error.status === 429;
  const isSessionExpired = error.status === 503;
  if (getHasRecaptchaFailed(errorMessage) && isInACQ173VariantB) {
    return handleRecaptchaFailed({
      state: getState(),
      message: errorMessage,
      statusCode: error.status,
      LocalLogger: LOG,
      endpointKey: EndpointKey.InitiateVerification,
      dispatch
    });
  } else if (getIsMissingRecaptchaInformation(errorMessage)) {
    return handleRecaptchaMissingInformation({
      message: errorMessage,
      dispatch,
      endpointKey: EndpointKey.InitiateVerification
    });
  }
  if (isRateLimitedError) {
    return dispatch(setError(ErrorKey.RateLimitedEmailVerification, error));
  }
  if (isSessionExpired) {
    return dispatch(setError(ErrorKey.SessionExpired));
  }
  return dispatch(setError(ErrorKey.EmailVerificationFailed, error));
};